var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.10938 7.19946H9.30929V14.3989H8.10938V7.19946Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.709 7.19946H12.9089V14.3989H11.709V7.19946Z",
    fill: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.30957 3.59985V4.79977H4.50948V16.7989C4.50948 17.1171 4.6359 17.4223 4.86093 17.6474C5.08596 17.8724 5.39116 17.9988 5.70939 17.9988H15.3087C15.6269 17.9988 15.9321 17.8724 16.1572 17.6474C16.3822 17.4223 16.5086 17.1171 16.5086 16.7989V4.79977H17.7085V3.59985H3.30957ZM5.70939 16.7989V4.79977H15.3087V16.7989H5.70939Z",
    fill: ""
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10938 1.19995H12.909V2.39986H8.10938V1.19995Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.4c519aefa4a29345a1391bc2e0ef1753.svg";
export { ForwardRef as ReactComponent };